export enum AlternativeRowType {
  Extra = 'extra',
  Unit = 'unit',
  UnitCustom = 'custom',
}
